import { Hourglass } from "lucide-react";

import { Navbar } from "@/components/Navbar";
import { useAuth } from "@/context/AuthContext";
import PatientDashboard from "@/pages/patient/PatientDashboard";
import ProDashboard from "@/pages/professional/ProDashboard";

function PendingApproval({ status }) {
  return (
    <div className="max-w-xl mx-auto px-4 py-24 text-center" data-testid="pending-approval-screen">
      <span className="h-14 w-14 rounded-2xl bg-amber-100 flex items-center justify-center mx-auto mb-6">
        <Hourglass className="h-7 w-7 text-amber-600" strokeWidth={1.5} />
      </span>
      <h1 className="text-2xl sm:text-3xl font-bold mb-3">
        {status === "rejected" ? "Tu solicitud fue rechazada" : "Tu cuenta está en revisión"}
      </h1>
      <p className="text-muted-foreground leading-relaxed">
        {status === "rejected"
          ? "Un administrador rechazó tu solicitud de cuenta profesional. Contacta a la clínica para más información."
          : "Un administrador de TransSalud revisará tu cuenta de profesional de la salud. Te notificaremos por correo cuando sea aprobada."}
      </p>
    </div>
  );
}

export default function Dashboard() {
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      {user.role === "patient" && <PatientDashboard />}
      {(user.role === "professional" || user.role === "admin") &&
        (user.role === "admin" || user.approval_status === "approved" ? (
          <ProDashboard />
        ) : (
          <PendingApproval status={user.approval_status} />
        ))}
    </div>
  );
}
